
namespace Matrix.Workflow {

    @Serenity.Decorators.registerClass()
    export class WorkflowInstanceGrid extends SiteEntityGrid<WorkflowInstanceRow, any> {
        protected getColumnsKey() { return 'Workflow.WorkflowInstance'; }
        protected getDialogType() { return WorkflowInstanceDialog; }
        protected getIdProperty() { return WorkflowInstanceRow.idProperty; }
        protected getLocalTextPrefix() { return WorkflowInstanceRow.localTextPrefix; }
        protected getService() { return WorkflowInstanceService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getButtons() {
            return super.getButtons().filter(x => x.cssClass != "add-button");
        }

        protected excelExportAction() {
            return "ExcelExport";
        }
    }

    export let WorkflowInstanceNamedFields = {
        "Class1": true,
        "Class2": true,
        "Class3": true,
        "Class4": true,
        "Class5": true,
        "Key1": true,
        "Key2": true,
        "Key3": true,
        "Key4": true,
        "Key5": true,
        "C1": true,
        "C2": true,
        "C3": true,
        "C4": true,
        "C5": true,
        "C6": true,
        "C7": true,
        "C8": true,
        "C9": true,
        "C10": true,
        "B1": true,
        "B2": true,
        "B3": true,
        "B4": true,
        "B5": true,
        "B6": true,
        "B7": true,
        "B8": true,
        "B9": true,
        "B10": true,
        "N1": true,
        "N2": true,
        "N3": true,
        "N4": true,
        "N5": true,
        "N6": true,
        "N7": true,
        "N8": true,
        "N9": true,
        "N10": true,
        "F1": true,
        "F2": true,
        "F3": true,
        "F4": true,
        "F5": true,
        "F6": true,
        "F7": true,
        "F8": true,
        "F9": true,
        "F10": true,
        "D1": true,
        "D2": true,
        "D3": true,
        "D4": true,
        "D5": true,
        "Txt1": true,
        "Txt2": true,
        "Txt3": true,
        "Txt4": true,
        "Txt5": true
    }

}